import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/no-image.png'


const _hoisted_1 = { style: {"margin":"20px 0"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Filter ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Display Attribute")
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { class: "mr-10" }, [
  /*#__PURE__*/_createVNode("strong", null, "Target: ")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "box-card"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Search ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Clear ")
const _hoisted_8 = {
  key: 1,
  src: _imports_0,
  alt: "logo",
  fit: "contain",
  width: "66"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  size: "medium"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Yes")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("No")
const _hoisted_20 = { class: "dialog-footer" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Cancel")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_popover = _resolveComponent("el-popover")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 16 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFilter = !_ctx.showFilter))
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_el_popover, {
                placement: "bottom",
                width: 400,
                trigger: "click"
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "warning",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox_group, {
                        span: 12,
                        modelValue: _ctx.defaultAttributeSelected,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.defaultAttributeSelected = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listAttributes, (attr) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              label: attr.name,
                              key: attr.name,
                              name: "type"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(attr.name.charAt(0).toUpperCase() + attr.name.slice(1)), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.connectionTarget.length > 0)
            ? (_openBlock(), _createBlock(_component_el_col, {
                key: 0,
                span: 8
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form, { style: {"text-align":"right"} }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.targetSelected,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.targetSelected = $event)),
                        placeholder: "Select",
                        size: "small",
                        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getSearchData()))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.connectionTarget, (connect, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              selected: [index === 0 ? _ctx.selected : _ctx.notSelected],
                              key: index,
                              label: connect.name,
                              value: connect._id
                            }, null, 8, ["selected", "label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    (_ctx.showFilter)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_el_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, { gutter: 30 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "SKU" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.condition.sku,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.condition.sku = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "Title" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.condition.title,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.condition.title = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { gutter: 30 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            size: "small",
                            type: "success",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getSearchData()))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_button, {
                            size: "small",
                            type: "primary",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleClear()))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_table, {
      data: _ctx.listData,
      ref: "multipleTable",
      width: "100",
      onSelectionChange: _ctx.handleSelectionChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "44"
        }),
        _createVNode(_component_el_table_column, {
          prop: "images",
          width: "90"
        }, {
          default: _withCtx((scope) => [
            (scope.row.hasImage)
              ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 0,
                  style: {"width":"66px","height":"66px"},
                  src: scope.row.firstImage,
                  fit: "scale-down"
                }, null, 8, ["src"]))
              : (_openBlock(), _createBlock("img", _hoisted_8))
          ]),
          _: 1
        }),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.defaultAttributeSelected, (attr, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            key: index,
            label: attr.charAt(0).toUpperCase() + attr.slice(1),
            prop: attr,
            "min-width": "200",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              (attr != 'status' && attr != 'isParent')
                ? (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(scope.row[attr]), 1))
                : _createCommentVNode("", true),
              (attr == 'isParent')
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    (scope.row.isParent)
                      ? (_openBlock(), _createBlock("p", _hoisted_11, "Yes"))
                      : (_openBlock(), _createBlock("p", _hoisted_12, "No"))
                  ]))
                : _createCommentVNode("", true),
              (attr == 'status')
                ? (_openBlock(), _createBlock("div", _hoisted_13, [
                    (scope.row.inProgress)
                      ? (_openBlock(), _createBlock("div", _hoisted_14, [
                          _createVNode(_component_el_tooltip, {
                            class: "item",
                            effect: "light",
                            content: "in progress",
                            placement: "right"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "warning",
                                icon: "el-icon-close",
                                circle: "",
                                size: "small"
                              })
                            ]),
                            _: 1
                          })
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_15, [
                          (scope.row.completed)
                            ? (_openBlock(), _createBlock("div", _hoisted_16, [
                                _createVNode(_component_el_tooltip, {
                                  class: "item",
                                  effect: "light",
                                  content: "Completed",
                                  placement: "right"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      type: "success",
                                      icon: "el-icon-check",
                                      circle: "",
                                      size: "small"
                                    })
                                  ]),
                                  _: 1
                                })
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_17, [
                                (
                    scope.row.numberOfRetry < 5 ||
                    scope.row.numberOfRetry === undefined
                  )
                                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                      key: 0,
                                      class: "item",
                                      effect: "light",
                                      content: "Failed",
                                      placement: "right"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "warning",
                                          icon: "el-icon-close",
                                          circle: "",
                                          size: "small"
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_el_tooltip, {
                                      key: 1,
                                      class: "item",
                                      effect: "light",
                                      content: "Failed",
                                      placement: "right"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "danger",
                                          icon: "el-icon-close",
                                          circle: "",
                                          size: "small"
                                        })
                                      ]),
                                      _: 1
                                    }))
                              ]))
                        ]))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["label", "prop"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          label: "Sync Error",
          prop: "message",
          "min-width": "230",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "Inspect",
          width: "120"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tooltip, {
              class: "item",
              effect: "light",
              content: "Detail",
              placement: "right"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: ($event: any) => (_ctx.handleOpenProductDetail(scope.row)),
                  icon: "el-icon-document",
                  size: "small",
                  type: "primary"
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "onSelectionChange"]),
    _createVNode(_component_el_dialog, {
      title: _ctx.titleModal,
      modelValue: _ctx.dialogProductDetail,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.dialogProductDetail = $event)),
      width: "1000px"
    }, {
      footer: _withCtx(() => [
        _createVNode("span", _hoisted_20, [
          _createVNode(_component_el_button, {
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.dialogProductDetail = false))
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "form",
          model: _ctx.dataProductDetail,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listAttributes, (attr, index) => {
                  return (_openBlock(), _createBlock(_component_el_col, {
                    span: 20,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      (attr.name == 'description' || attr.name == 'images')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: attr.name,
                            "label-width": "250px"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.dataProductDetail[attr.name],
                                "onUpdate:modelValue": ($event: any) => (_ctx.dataProductDetail[attr.name] = $event),
                                type: "textarea",
                                rows: 4,
                                disabled: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        : _createCommentVNode("", true),
                      (
              attr.name != 'isParent' &&
              attr.name != 'status' &&
              attr.name != 'timeStamp' &&
              attr.name != 'description' &&
              attr.name != 'images'
            )
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: attr.name,
                            "label-width": "250px"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.dataProductDetail[attr.name],
                                "onUpdate:modelValue": ($event: any) => (_ctx.dataProductDetail[attr.name] = $event),
                                type: "text",
                                disabled: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "Last Updated",
                      "label-width": "250px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.dataProductDetail.dateUpdated,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dataProductDetail.dateUpdated = $event)),
                          type: "text",
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "Is Parent",
                      "label-width": "250px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          disabled: "",
                          modelValue: _ctx.dataProductDetail.isParent,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.dataProductDetail.isParent = $event)),
                          placeholder: "No",
                          width: "100%"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "Yes",
                              value: true
                            }, {
                              default: _withCtx(() => [
                                _hoisted_18
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_option, {
                              label: "No",
                              value: false
                            }, {
                              default: _withCtx(() => [
                                _hoisted_19
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (!_ctx.dataProductDetail.isParent && _ctx.dataProductDetail.skuParent)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 0,
                      span: 20
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "Parent SKU",
                          "label-width": "250px"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.dataProductDetail.skuParent,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dataProductDetail.skuParent = $event)),
                              type: "text",
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.dataProductDetail.history && _ctx.dataProductDetail.history.length)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "Sync Error",
                  "label-width": "250px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.dataProductDetail.history[0].error,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.dataProductDetail.history[0].error = $event)),
                      type: "textarea",
                      rows: 4,
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ], 64))
}